import { useQuery } from "@tanstack/react-query";
import { fetchFloorPlans } from "../api/fetch-floor-plans";

export const FLOOR_PLANS_QUERY_KEY = "floorPlans";

export function useFloorPlans(branchUid: string | undefined, versionId?: number) {
  return useQuery({
    queryKey: [FLOOR_PLANS_QUERY_KEY, branchUid, versionId],
    queryFn: () => fetchFloorPlans(branchUid!, versionId),
    enabled: Boolean(branchUid),
  });
}
